var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.playables),function(item,index){return [_c('playables-list-item',{attrs:{"data":item,"routable":true}}),(index + 1 < _vm.playables.length)?_c('v-divider'):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }